import React from 'react'
import { Link } from 'react-router-dom'
import { useAuthState } from '../AuthProvider'

const BackToHomeLink = () => {
  const { isAuthenticated } = useAuthState()

  return isAuthenticated ? (
    <Link to="/">Back to Home</Link>
  ) : (
    <>
     
      <Link to="/">Sign In</Link>
    </>
  )
}

export default BackToHomeLink
